import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { trackPageView } from './gtm'

export function useGtmPageTracking(): void {
  const location = useLocation()
  const didInitialTrack = useRef(false)

  useEffect(() => {
    const page = location.pathname + location.search

    if (!didInitialTrack.current) {
      didInitialTrack.current = true
      trackPageView(page)
      return
    }

    trackPageView(page)
  }, [location.pathname, location.search])
}
